<template>
  <base-container>
    <el-form
      ref="adForm"
      :model="formData"
      :rules="rules"
      size="medium"
      label-width="100px"
    >
      <el-form-item label="公告标题" prop="title">
        <el-input
          v-model="formData.title"
          placeholder="请输入公告标题"
          show-word-limit
          clearable
          maxlength="100"
          :style="{ width: '100%' }"
        />
      </el-form-item>
      <el-form-item label="是否注册发送" prop="isRegister">
        <el-select v-model="formData.isRegister" placeholder="请选择">
          <el-option label="否" :value="0"></el-option>
          <el-option label="是" :value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="展示图片" prop="displayImg">
        <single-upload-cos
          v-model="formData.picUrl"
          upload-tip="(656px*360px) 支持jpg/png/jpeg格式"
        />
      </el-form-item>
      <el-form-item label="概述" prop="summary">
        <el-input
          v-model="formData.summary"
          type="textarea"
          placeholder="请输入概述"
          show-word-limit
          maxlength="250"
          :autosize="{ minRows: 4, maxRows: 4 }"
          :style="{ width: '100%' }"
        />
      </el-form-item>
      <el-form-item label="点击效果" prop="showType">
        <el-radio-group v-model="formData.showType" size="medium">
          <el-radio
            v-for="(item, index) in showTypeOptions"
            :key="index"
            border
            :label="item.value"
          >{{ item.label }}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        v-show="formData.showType == 2"
        label="跳转连接"
        prop="link"
      >
        <el-input
          v-model="formData.link"
          placeholder="请输入跳转连接(http://xxx.com)"
          clearable
          :style="{ width: '100%' }"
        />
      </el-form-item>
      <el-form-item
        v-show="formData.showType === 3"
        label="富文本"
        prop="richtext"
      >
        <tinymce v-model="formData.richtext" />
      </el-form-item>
      <el-form-item size="large">
        <el-button type="primary" class="mr8" @click="submitForm">提交</el-button>
        <el-button @click="resetForm">重置</el-button>
      </el-form-item>
    </el-form>
  </base-container>
</template>
<script>
import Tinymce from '@/components/Tinymce'
import { addOrUpdateAnnounce, getAnnounceInfo } from '@/api/announce'
import SingleUploadCos from '@/components/upload/single-upload-cos.vue'
export default {
  name: 'AnnounceAdd',
  components: {
    Tinymce,
    SingleUploadCos
  },
  props: [],
  data() {
    return {
      formData: {
        id: null,
        title: '',
        picUrl: '',
        summary: '',
        showType: 1,
        link: null,
        richtext: null,
        isRegister:0
      },
      rules: {
        title: [
          {
            required: true,
            message: '请输入公告标题',
            trigger: 'blur'
          }
        ],
        isRegister:[
          {
            required: true,
            message: '请选择',
            trigger: 'blur'
          }
        ],
        summary: [
          {
            required: true,
            message: '请输入概述',
            trigger: 'blur'
          }
        ],
        showType: [
          {
            required: true,
            message: '请选择点击效果',
            trigger: 'change'
          }
        ],
        link: [
          {
            type: 'url',
            message: '跳转连接不合法(示例：https://jd.com)',
            whitespace: true,
            trigger: ['blur', 'change']
          }
        ],
        richtext: [
          {
            message: '富文本不能为空',
            min: 0,
            whitespace: true,
            trigger: ['blur', 'change']
          }
        ]
      },
      showTypeOptions: [
        {
          label: '无效果',
          value: 1
        },
        {
          label: '跳转连接',
          value: 2
        },
        {
          label: '富文本',
          value: 3
        }
      ]
    }
  },
  mounted() {
    this.initData()
  },
  methods: {
    initData() {
      const { id } = this.$route.query
      if (id) {
        getAnnounceInfo({ id }).then((res) => {
          this.formData = res.data
        })
      }
    },
    submitForm() {
      this.$refs['adForm'].validate((valid) => {
        if (!valid) return
        // TODO 提交表单
        const { formData } = this;
        addOrUpdateAnnounce(formData).then((res) => {
          if (res.code === '00000') {
            this.$message({
              type: 'success',
              message: '操作成功',
              onClose: () => {
                this.$router.push({
                  path: '/content/announce'
                })
              }
            })
          }
        })
      })
    },
    resetForm() {
      this.$refs['adForm'].resetFields()
    }
  }
}
</script>
<style>
.el-upload__tip {
  line-height: 1.2;
}
</style>

